<script lang="ts" setup>
export interface PaginationLinkProps {
    pagination: Pagination
    link: VNuxtLinkTo
    isActive: boolean
    page: number
    ariaLabel?: string
}

const { $t } = useNuxtApp()

const props = withDefaults(defineProps<PaginationLinkProps>(), {
    ariaLabel: undefined,
})
const route = useRoute()
const to = computed<VNuxtLinkTo>(
    (): VNuxtLinkTo => ({
        ...props.link,
        query: {
            ...route.query,
            s: props.page,
        },
    })
)
</script>
<template>
  <li :class="{ 'mx-1': props.isActive }">
    <VNuxtLink
      class="pagination-link d-flex align-items-center justify-content-center text-decoration-none transition"
      :class="{ 'is-active': props.isActive }"
      :aria-current="props.isActive ? 'page' : undefined"
      :aria-label="props.ariaLabel || `${$t('Prejsť na stránku číslo')} ${props.page}`"
      :to="to"
      :label="String(props.page)"
    >
      <slot />
    </VNuxtLink>
  </li>
</template>
<style>
@import './PaginationLink.vars.scss';
</style>
<style lang="scss">
@import './PaginationLink.scss';
</style>
